import AbstractFilterClass from "./AbstractFilterClass";

export default class OrdersData extends AbstractFilterClass {
    constructor() {
        super();
        this.list();

        this.pagination();
        this.filters();
    }

    list() {
        let self = this;
        this.appInitial = new Vue({
            el: '#app-orders-history',
            delimiters: ['${', '}'],
            data: {
                html: null,
                count: 0,
            },
            methods: {
                getFilterData: function (params) {
                    let selfV = this;

                    self.preloader(true);
                    $.ajax({
                        type: "POST",
                        url: getOrdersList,
                        data: params,
                        dataType: "json",
                    }).then(function (resp) {
                        if(resp.success) {
                            selfV.html = resp.data.html;
                            selfV.count = resp.data.count;
                        }
                        self.preloader(false);
                    });
                }
            },
            computed: {
                getOrders: function () {
                    return this.html;
                },
                getCount: function () {
                    return this.count;
                }
            },
            mounted() {
                let selfV = this;
                $.ajax({
                    type: "POST",
                    url: getOrdersList,
                    dataType: "json",
                }).then(function (resp) {
                    if(resp.success) {
                        selfV.html = resp.data.html;
                        selfV.count = resp.data.count;
                    }
                });
            }
        });
    }
}
